import $ from "jquery";
import Splide from "@splidejs/splide";
$(function () {
	let carousel_and_text = document.querySelectorAll(".carousel_and_text");
	if (carousel_and_text.length > 0) {
		for (let i = 0; i < carousel_and_text.length; i++) {
			let carouselElement = carousel_and_text[i];
			let carouselDefaultOptions = {
				type: "loop",
				arrows: false,
			};
			let carousel = new Splide(carouselElement, carouselDefaultOptions);
			carousel.mount();
		}
	}
});
